import _ from "lodash";

var ActivityFactory = function ($http, $window) {
    return _.partial($http, {
        method: "GET",
        url: __baseApiUrl__ + "/participant-web-services/rest/nonauth/service/activity",
        timeout: 5000,
        responseType: "text"
    });
};

ActivityFactory.$inject = ["$http", "$window"];
export default ActivityFactory;
